// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cta--o3Pbo{border:1px solid #ccc7fc;border-radius:12px;background-color:#eeecfe}.avatar--_ULhk{width:36px;height:36px;border:2px solid #eeecfe;font-size:12px}.avatar--_ULhk+.avatar--_ULhk{margin-left:-10px}.avatar--_ULhk:nth-child(2){z-index:1}.avatar--_ULhk:nth-child(3){z-index:2}.avatar-1--_YYSQ{background-color:#5645f5}.avatar-2--ypYsw{background-color:#2e9e78}.avatar-3--xXryO{background-color:#c1502e}.dismiss--sCgFV{top:4px;right:4px}.cta--o3Pbo:has(.dismiss--sCgFV) .content--iQQbx{padding-right:20px}.compact--cSw9w .avatar--_ULhk{width:30px;height:30px;font-size:10px}.compact--cSw9w .avatar--_ULhk+.avatar--_ULhk{margin-left:-8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cta": "cta--o3Pbo",
	"avatar": "avatar--_ULhk",
	"avatar-1": "avatar-1--_YYSQ",
	"avatar-2": "avatar-2--ypYsw",
	"avatar-3": "avatar-3--xXryO",
	"dismiss": "dismiss--sCgFV",
	"content": "content--iQQbx",
	"compact": "compact--cSw9w"
};
export default ___CSS_LOADER_EXPORT___;
